import React from 'react';

import * as ht from './_ht';
import * as cr from './_cr';

import * as ica from 'src/ica';

import * as BoxC from './_ccbBoxC';
import * as TextC from './_ccbTextC';
import * as IconC from './_ccbIconC';

const _BtnC = React.memo((pz: ht.btnCz) => {

  if ( pz.cz?.bShow == false ) return null;

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.btnAbtz[_abtType] ? ica.btnAbtz[_abtType]() : ({} as ht.dz);

//console.log('BtnC 17: ' + JSON.stringify(_abtz));
  return (
    cr.c(BoxC.N, {
      key: 'Btn.root',
      boxStlz: {
        ..._abtz.boxStlz,
        ...pz.boxStlz
      },
      pslPtyz: pz.pslPtyz,
      oClds: [

        pz.oBfrCld ?
        pz.oBfrCld
        : null,

        pz.bfrIconCz ?
        cr.c(IconC.N, {
          key: -20,
          iconPtyz: {
            ... _abtz.bfrIconCz?.iconPtyz,
            ... pz.bfrIconCz?.iconPtyz,
          },
          boxStlz: {
            ... _abtz.bfrIconCz?.boxStlz,
            ... pz.bfrIconCz?.boxStlz,
          }
        })
        : null,

        (pz.lblCz) ?
        cr.c(TextC.N, {
          key: -30,
          ... pz.lblCz,
          boxStlz: {
            ... _abtz.lblCz?.boxStlz,
            ... pz.lblCz?.boxStlz,
          },
          textz: {
            ... pz.lblCz.textz,
            pfx: pz.lblCz?.textz?.pfx ?? _abtz.lblCz?.textz?.pfx,
            stlz: {
              ... _abtz.lblCz?.textz?.stlz,
              ... pz.lblCz?.textz?.stlz,
            },
          },
        })
        : null,

        pz.atrIconCz ?
        cr.c(IconC.N, {
          key: -40,
          iconPtyz: {
            ... _abtz.atrIconCz?.iconPtyz,
            ... pz.atrIconCz?.iconPtyz,
          },
          boxStlz: {
            ... _abtz.atrIconCz?.boxStlz,
            ... pz.atrIconCz?.boxStlz,
          }
        })
        : null,

        pz.oAtrCld ?
        pz.oAtrCld
        : null,

      ]
    })
  );
});
export const N = _BtnC;
